import React from "react";
import "../Styles/home.css";

import curvedTop from "../assests/images/curved-home-middle.png";

export default function WhatIsWedluk() {
  return (
    <section className="what-is-wedluk">
      <div className="curved-top">
        <img src={curvedTop} alt="Curved Top Decoration" />
      </div>
      <h2 className="section-title-for-home">What is Wedluk?</h2>
      <p className="section-description">
        Welcome to a modern, privacy‑focused, and secure matrimonial platform
        designed for both agents and today’s AI‑generation individuals.
      </p>
      <p className="section-description mt-4">
        Our trusted agent network seamlessly connects professionals, while
        individuals discover compatible matches through verified reference
        checks.
      </p>
      <p className="section-description mt-4">
        Experience upcoming AI‑powered matchmaking, enhanced trust features, and
        personalized, location‑based services tailored to your matrimonial
        journey.
        <span className="highlight">tailored to your matrimonial journey.</span>
      </p>
    </section>
  );
}
